import { mutate } from 'swr';
import axios from 'axios';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { getError } from '@shared/utils/helpers';
import { TTeamMemberType } from '../../../Roles/RoleModal/models/RoleAssignmentModel';
import { NTeamManager } from './interfaces';

const path = '/user-service/teams';

export const prepareUpdateRequest = (
  teamTypeId: string,
  periodId: string,
  teamManager: NTeamManager.Response,
  modifiedManagers: NTeamManager.User[],
) => {
  return {
    updateManagerRequests: modifiedManagers?.map(({ userName: _userName, ...manager }) => ({
      ...manager,
      teamTypeId,
      periodId,
    })),
    updateTeamRequests: teamManager?.teams?.map(({ id, name, teamTypeId, periodId, copiedFromTeamId, roleUsers }) => {
      const memberTypes: TTeamMemberType[] = roleUsers && (Object.keys(roleUsers) as TTeamMemberType[]);
      const setMemberType = (user: NTeamManager.User, teamMemberType: TTeamMemberType) => ({ ...user, teamMemberType });

      const users = memberTypes
        ?.map((memberType) => roleUsers[memberType]?.map((user) => setMemberType(user, memberType)))
        .flat();

      return {
        teamId: id || null,
        updateTeamRequest: {
          name,
          teamTypeId,
          periodId,
          copiedFromTeamId: copiedFromTeamId || null,
          users,
        },
      };
    }),
  } as unknown as NTeamManager.Request;
};

export const requestUpdateTeam = (request: NTeamManager.Request) => {
  return mutate(`${path}/managers`, async() => {
    try {
      await axios.patch(`${path}/managers`, request);
      Notistack.successMessage('Teams - Updated Successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};

export const requestDeleteTeam = (teamId: string) => {
  return mutate(`${path}/${teamId}`, async() => {
    try {
      await axios.delete(`${path}/${teamId}`);
      Notistack.successMessage('Team - Deleted Successfully');
    } catch {
      Notistack.generalError();
    }
  });
};
